/* tslint:disable */
/* eslint-disable */
/**
 * CarePlatform User Preferences API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    UserVideoBackgroundType,
    UserVideoBackgroundTypeFromJSON,
    UserVideoBackgroundTypeFromJSONTyped,
    UserVideoBackgroundTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdateUserVideoBackgroundRequest
 */
export interface UpdateUserVideoBackgroundRequest {
    /**
     * 
     * @type {UserVideoBackgroundType}
     * @memberof UpdateUserVideoBackgroundRequest
     */
    videoBackgroundType: UserVideoBackgroundType;
    /**
     * The UUID of the file
     * @type {string}
     * @memberof UpdateUserVideoBackgroundRequest
     */
    videoBackgroundFileId?: string;
}

export function UpdateUserVideoBackgroundRequestFromJSON(json: any): UpdateUserVideoBackgroundRequest {
    return UpdateUserVideoBackgroundRequestFromJSONTyped(json, false);
}

export function UpdateUserVideoBackgroundRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserVideoBackgroundRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'videoBackgroundType': UserVideoBackgroundTypeFromJSON(json['videoBackgroundType']),
        'videoBackgroundFileId': !exists(json, 'videoBackgroundFileId') ? undefined : json['videoBackgroundFileId'],
    };
}

export function UpdateUserVideoBackgroundRequestToJSON(value?: UpdateUserVideoBackgroundRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'videoBackgroundType': UserVideoBackgroundTypeToJSON(value.videoBackgroundType),
        'videoBackgroundFileId': value.videoBackgroundFileId,
    };
}


